import { createObj } from "../Docs/fable_modules/fable-library.3.7.1/Util.js";
import { singleton } from "../Docs/fable_modules/fable-library.3.7.1/List.js";
import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";
import { map } from "../Docs/fable_modules/fable-library.3.7.1/Seq.js";

function setState(name, s, table) {
    const o = createObj(singleton([name, s]));
    table._obj.setState(o);
    return table;
}

export class Table {
    constructor() {
    }
}

export function Table$reflection() {
    return class_type("Feliz.TanStack.Table.TableState.Table", void 0, Table);
}

export function Table_getState_Z4395D14A(table) {
    return table._obj.getState();
}

export function Table_setData(data, table) {
    table._obj.options.data = data;
    const b = { _obj: table._obj };
    const a = {
        Data: data,
    };
    return { ...a, ...b };
}

export function Table_setColumnVisibilityState(visibility, table) {
    return setState("columnVisibility", visibility, table);
}

export function Table_setColumnOrderState(order, table) {
    return setState("columnOrder", order, table);
}

export function Table_setColumnPinningState(pinning, table) {
    return setState("columnPinning", pinning, table);
}

export function Table_setColumnFiltersState(filters, table) {
    return setState("columnFilters", filters, table);
}

export function Table_setColumnSortingState(sorting, table) {
    return setState("columnSorting", sorting, table);
}

export function Table_setExpandedState(expanded, table) {
    return setState("expanded", expanded, table);
}

export function Table_setColumnGroupingState(grouping, table) {
    return setState("grouping", grouping, table);
}

export function Table_setColumnSizingState(sizing, table) {
    return setState("columnSizing", createObj(map((tupledArg) => [tupledArg[0], tupledArg[1]], sizing)), table);
}

export function Table_setColumnSizingInfoState(sizingInfo, table) {
    return setState("columnSizingInfo", sizingInfo, table);
}

export function Table_setPaginationState(paginationState, table) {
    return setState("pagination", paginationState, table);
}

export function Table_setRowSelectionState(rowSelection, table) {
    return setState("rowSelection", createObj(map((tupledArg) => [tupledArg[0], tupledArg[1]], rowSelection)), table);
}

//# sourceMappingURL=TableState.fs.js.map
